import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { Modal, FormLayout, DropZone, Checkbox, TextStyle } from '@shopify/polaris';
import { Formik } from 'formik';
import BasicTextField from '@presentational/BasicTextField';
import { tAttribute } from '@utils';
import * as Yup from 'yup';

import AutocompleteSearch from '@presentational/AutocompleteSearch';

import ImageDropZone from '@presentational/ImageDropZone';

const AppLinkSchema = Yup.object().shape({
  title: Yup.string().required('Required'),
  url: Yup.string().required('Required'),
  position: Yup.number().required('Required'),
  class_name: Yup.string().nullable(),
});

const propTypes = {
  link: PropTypes.object.isRequired,
  open: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,

  errors: PropTypes.array,
  title: PropTypes.string.isRequired,
  ctaTitle: PropTypes.string.isRequired,
  fetchCollectionURL: PropTypes.string.isRequired,
  collectionBaseURL: PropTypes.string.isRequired,
  deepLevel: PropTypes.number, // deepLevel where link is nested (0 if top level)
}

const defaultProps = {
  open: false,
  deepLevel: 0,
}

const AppLinkModal = (props) => {

  const handleSubmit = (values, formikBag) => {
    props.handleSubmit(values);
    // formikBag.resetForm
  }

  // TODO use useFormik when upgrade to 2.0
  const handleCollectionSelection = (selectedValue, selectedCollection, formikProps) => {
    const newValues = { 
      ...formikProps.values, 
      url: `${props.collectionBaseURL}/${selectedCollection.handle}`,
      title: !!formikProps.values.title ?  formikProps.values.title : selectedCollection.title,
      shopify_collection_id: selectedValue[0],
    }
    formikProps.setValues(newValues);
  }

  const handleUrlChange = (_id, value, formikProps) => {
    formikProps.setValues({
      ...formikProps.values, 
      url: value,
      shopify_collection_id: null, // If manually change ID then this gets nulled
    });
  }

  const handleImageDrop = (acceptedFiles, formikProps) => {
    formikProps.setValues({
      ...formikProps.values,
      imageUpload: acceptedFiles[0],
      remove_image: null,
    })
  }

  const handleImageRemove = (formikProps) => {
    formikProps.setValues({
      ...formikProps.values,
      imageUpload: null,
      existingImage: null, // to display
      image_url: null, 
      remove_image: true // Remove actual image if any
    })
  }

  return (
    <Formik
      initialValues={{
        ...props.link,
        existingImage: props.link.image_url ? { url: props.link.image_url } : null
      }}
      onSubmit={ handleSubmit }
      validationSchema={ AppLinkSchema }
      enableReinitialize
    >
      { (formikProps) => 
        <Modal
          open={ props.open }
          large
          title={ props.title }
          onClose={ props.onClose }

          primaryAction={{
            content: props.ctaTitle,
            onAction: formikProps.handleSubmit,
            disabled: !formikProps.isValid,
          }}
          secondaryActions={{
            content: I18n.t("actions.cancel"),
            onAction: props.onClose,
          }}
        >
          <Modal.Section>
            <FormLayout>
              { console.log("Modal", props) }
              {/* { console.log("Modal errors",formikProps.errors) } */}
              <BasicTextField 
                name="title"
                label={ tAttribute("general", "title") }
                handleChange={ (value, id) => formikProps.setFieldValue(id, value) }
                values={ formikProps.values }
                errors={ formikProps.errors }
              />

              {/* Is only relevant to third level links */}
              { props.deepLevel === 3 &&
                <div className='flex flexColumn'>
                  <Checkbox
                    label={ tAttribute("app_link", "categorization_enabled") }
                    checked={ formikProps.values.categorization_enabled }
                    onChange={ (value) => formikProps.setFieldValue("categorization_enabled", value) }
                  />
                  
                  <TextStyle variation='subdued'>
                    <strong>Importante: </strong>No seleccionar en menús genéricos como <em>Ver todo, Ofertas</em> o <em>Envío rápido.</em>
                  </TextStyle>
                </div>
              }
  
              {/* handled outside */}
              {/* <BasicTextField 
                name="position"
                label={ tAttribute("app_link", "position") }
                handleChange={ (value, id) => formikProps.setFieldValue(id, value) }
                values={ formikProps.values }
                errors={ formikProps.errors }
                type="number"
              /> */}

              <BasicTextField 
                name="class_name"
                label={ tAttribute("app_link", "class_name") }
                handleChange={ (value, id) => formikProps.setFieldValue(id, value) }
                values={ formikProps.values }
                errors={ formikProps.errors }
              />

              <AutocompleteSearch
                label="Shopify Collection"
                apiURL={ props.fetchCollectionURL }
                onSelectionCallback={ (value, item) => handleCollectionSelection(value, item, formikProps) }
                itemLabelAccessor="title"
                itemValueAccessor="id"
              />

              <FormLayout.Group>
                <BasicTextField 
                  name="url"
                  readOnly
                  label={ tAttribute("app_link", "url") }
                  handleChange={ (value, id) =>  handleUrlChange(id, value, formikProps) }
                  values={ formikProps.values }
                  errors={ formikProps.errors }
                />

                <BasicTextField 
                  name="shopify_collection_id"
                  readOnly
                  label={ tAttribute("app_link", "shopify_collection_id") }
                  handleChange={ (value, id) => formikProps.setFieldValue(id, value) }
                  values={ formikProps.values }
                  errors={ formikProps.errors }
                />
              </FormLayout.Group>

              <BasicTextField
                name="url_web"
                placeholder="https://www.store.com/some-url?utm_source=banners&utm_medium=xyz&utm_campaign=CampaignName"
                label={ tAttribute("banner", "url_web") }
                handleChange={ (value, id) => formikProps.setFieldValue(id, value) }
                values={ formikProps.values }
                errors={ formikProps.errors }
                helpText="URL aplica solo para web y sobrescribe la selección de Collection o Product"
              />

              <ImageDropZone
                onDrop={ (_dropFiles, acceptedFiles, _rejectedFiles) => handleImageDrop(acceptedFiles, formikProps) }
                label={ "Imagen" }
                imageFile={ formikProps.values.imageUpload || formikProps.values.existingImage  }
                onDelete={ () => handleImageRemove(formikProps) }
              />
            </FormLayout>
          </Modal.Section>
        </Modal>
      }
    </Formik>
  )
};

AppLinkModal.propTypes = propTypes;
AppLinkModal.defaultProps = defaultProps;

export default AppLinkModal;